<template>
  <div class="uid-token-login-popup" v-if="visible">
    <div class="popup-shadow" @click="hideUidTokenLoginPopup"></div>
    <div class="popup-container">
      <div class="title">{{ popupModeTitle }}</div>
      <uid-token-login :isJpUidTokenLogin="true" :isPopupMode="true" :defaultUid="uid"
        @loginSuccess="loginSuccess"></uid-token-login>
      <protocol-link></protocol-link>
      <div class="popup-close" @click="hideUidTokenLoginPopup"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import UidTokenLogin from '@components/officialWebStore/login/UidTokenLogin.vue';
import ProtocolLink from '@components/officialWebStore/login/ProtocolLink.vue';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      uid: state => state.login.uid
    }),
    ...mapGetters(['getCoinsName']),
    popupModeTitle() {
      return this.letter.coinsPayTokenLogin.replace(
        '\${Z-BIT}',
        this.getCoinsName
      );
    }
  },
  methods: {
    hideUidTokenLoginPopup() {
      this.$emit('update:visible', false);
    },
    loginSuccess() {
      this.hideUidTokenLoginPopup();
    }
  },
  components: {
    ProtocolLink,
    UidTokenLogin
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';

.uid-token-login-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}

.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-left: 10px;
  padding-right: 70px;
  height: 87px;
  line-height: 32px;
  font-size: 20px;
  @include g-popup-title();
  margin: 0;
  border-radius: 10px;
}

.popup-close {
  position: absolute;
  right: 32px;
  top: 27px;
  background: url($tmslgImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;

    ::v-deep .uid-token-content {
      width: 100%;
    }

    ::v-deep .uid-token .input-box {
      height: 70px;
      margin-bottom: 10px;
    }

    ::v-deep .third-login .space .line {
      width: 368px;
    }
  }

  .title {
    height: 61px;
    line-height: 28px;
    font-size: 22px;
    padding-right: 50px;
  }

  .popup-close {
    position: absolute;
    right: 15px;
    top: 19px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-size: cover;
  }
}
</style>
